import Reveal from '@/components/base/Reveal';
import { featuredPosts } from '@/mocks/home';

export default function FeaturedStrip() {
  return (
    <section id="featured" className="bg-background-100 border-y border-background-200">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
              <span className="inline-flex items-center gap-2 text-primary-600 text-xs md:text-sm font-bold tracking-wide">
                <i className="ri-flashlight-line"></i>
                今日入口
              </span>
              <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950 tracking-tight">
                今日最新新料，抢先看
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
                黑料福利更新时刻，先把今天讨论最猛的几条挑出来。点开任意一条都能进入话题墙继续围观。
              </p>
            </div>
            <a
              href="#latest"
              className="cursor-pointer whitespace-nowrap inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors shrink-0"
            >
              查看全部今日更新
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </Reveal>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredPosts.map((post, index) => (
            <Reveal key={post.seq} delay={index * 90}>
              <article className="group h-full bg-background-50 border border-background-200 rounded-lg overflow-hidden transition-colors hover:border-primary-300 cursor-pointer">
                <div className="relative w-full h-48 md:h-52 overflow-hidden">
                  <img
                    src={post.image}
                    alt={`黑料福利今日话题：${post.title}`}
                    title={`黑料福利 ${post.tag} 最新`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/95 text-primary-700 text-xs font-bold">
                    {post.tag}
                  </span>
                  <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-full bg-foreground-950/70 text-background-50 text-xs font-medium">
                    {post.time}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                    {post.title}
                  </h3>
                  <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {post.excerpt}
                  </p>
                  <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-chat-1-line"></i>
                      {post.comments}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-accent-700 font-medium">
                      <i className="ri-fire-line"></i>
                      {post.heat}
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}